export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.30-1559.33",
  commitId: "45f6d78e733603aff59cca8889e0beaf586cf329",
  commitTime: "2026-09-30T15:59:33.000Z",
});
